import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from "../../../modules/environment";
import {logout} from "../../../redux/actions/UserActions";
import {main_dashbaord_show_hello} from "../../../redux/actions/MainDashboardActions";

const whatsapp = `${process.env.PUBLIC_URL}/img/whatsapp.gif`;
const whatsapp40 = `${process.env.PUBLIC_URL}/img/watsapp40.png`;

class Topbar extends PureComponent {
    static propTypes = {
        changeMobileSidebarVisibility: PropTypes.func.isRequired,
        changeSidebarVisibility: PropTypes.func.isRequired,
    };

    render() {
        const {changeMobileSidebarVisibility, changeSidebarVisibility, isScreen} = this.props;

        let tmpIsScreen = (!(isScreen === false || isScreen === 0));

        let isMobile = environment.isMobile();

        let classname = '';

        if(TextManager.getCurrentDashboard() === 'simple')
            classname = "topbar__logo";
        else if(TextManager.getCurrentDashboard() === 'qmobile')
            classname = "topbar__logo_qmobile";
        else if(TextManager.getCurrentDashboard() === 'allsim')
            classname = "topbar__logo_allsim";
        else if(TextManager.getCurrentDashboard() === 'all-sim')
            classname = "topbar__logo_allsim";
        else if(TextManager.getCurrentDashboard() === 'tenecom')
            classname = "topbar__logo_tenecom";
        else if(TextManager.getCurrentDashboard() === 'onestop')
            classname = "topbar__logo_onestop";

        let isAllSims = false;
        if(TextManager.getCurrentDashboard() === 'allsim') {
            isAllSims = true;
        }

        let isAll_Sims = false;
        if(TextManager.getCurrentDashboard() === 'all-sim') {
            isAll_Sims = true;
        }

        let isTenecom = false;
        if(TextManager.getCurrentDashboard() === 'tenecom') {
            isTenecom = true;
        }

        let isOneStop = false;
        if(TextManager.getCurrentDashboard() === 'onestop') {
            isOneStop = true;
        }


        return (
            <div className="topbar">
                <div className="topbar__wrapper">
                    <div className="topbar__left">
                        {tmpIsScreen && <Link className='topbar__logo_exit' to="/dashboard" style={{marginLeft: '30px'}}
                                           onClick={()=>{ this.props.dispatch(logout());
                                                          this.props.dispatch(main_dashbaord_show_hello())}}/>}
                    </div>
                    <div className="topbar__right">
                        {/* Desktop */}
                        {this.props.showNumber && !isAllSims && !isMobile && !isAll_Sims && !isTenecom && !isOneStop &&
                            <h3 style={{textAlign: 'right', color: 'green', marginTop: 'auto', marginBottom: 'auto', marginRight: '10px'}}>(במקרים דחופים בלבד ניתן להתקשר 0733998090)</h3>}
                        {/* Mobile */}
                        {this.props.showNumber && !isAllSims && isMobile && !isAll_Sims && !isTenecom && !isOneStop &&
                            <h6 style={{textAlign: 'right', color: 'green', marginTop: 'auto', marginBottom: 'auto'}}>(במקרים דחופים בלבד ניתן להתקשר 0733998090)</h6>}

                        {!isAllSims && !isAll_Sims && !isTenecom && !isOneStop && <li className='sidebar__link' style={{height: 'auto', width: '80px'}}
                            onClick={(e) => {
                            e.preventDefault();
                            window.open('https://wa.me/972733998090', '_blank');
                        }}>
                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                 src={whatsapp40} alt="catalog-item-img" />
                        </li>}

                        {/* Desktop */}
                        {!isAllSims && !isAll_Sims && !isMobile && !isTenecom && !isOneStop && <h3 style={{textAlign: 'right', color: 'green', marginTop: 'auto', marginBottom: 'auto', marginRight: '100px'}}> - זמינים לשירותכם בוואטסאפ</h3>}
                        {/* Mobile */}
                        {!isAllSims && !isAll_Sims && isMobile && !isTenecom && !isOneStop && <h6 style={{textAlign: 'right', color: 'green', marginTop: 'auto', marginBottom: 'auto'}}> - זמינים לשירותכם בוואטסאפ</h6>}

                        <Link className={classname} to="/dashboard"/>
                        {/*<Link className={TextManager.getCurrentDashboard() === 'simple' ? "topbar__logo" : "topbar__logo_qmobile"} to="/dashboard"/>*/}
                        {!isScreen && <TopbarSidebarButton
                            changeMobileSidebarVisibility={changeMobileSidebarVisibility}
                            changeSidebarVisibility={changeSidebarVisibility}
                        />}
                    </div>
                </div>
            </div>
        );
    }
}

export default Topbar;
